import { Fragment } from "react";

function StandardTwoSectionCard({
  bg,
  bg_image,
  title_text,
  button_text,
  heading_color = "#1a7a45", // Fallback default color if none passed
  onButtonClick,
  children,
}) {
  // --- THE HEX-TO-RGBA MATRIX ---
  const getButtonBgColor = (hex) => {
    // Clean the hex string if it has a '#'
    const cleanHex = hex.replace("#", "");

    // Parse the r, g, b values
    const r = parseInt(cleanHex.substring(0, 2), 16);
    const g = parseInt(cleanHex.substring(2, 4), 16);
    const b = parseInt(cleanHex.substring(4, 6), 16);

    // Return the custom 8% alpha transparency background
    return `rgba(${r}, ${g}, ${b}, 0.08)`;
  };

  // Generate the background color string safely
  const computedBg = heading_color.startsWith("#")
    ? getButtonBgColor(heading_color)
    : "rgba(26, 122, 69, 0.08)"; // Safe hardcoded fallback if it's not a hex

  return (
    <Fragment>
      <div className="two-sections-card">
        <div className="header-section-card">
          <div className="banner-card">
            <img
              src={`${process.env.PUBLIC_URL}/images/${bg_image}`}
              alt="Background Image"
            />
          </div>
          {/* Apply Heading Color to text */}
          <p
            className="badget-title"
            style={{ color: heading_color, backgroundColor: computedBg }}
          >
            {title_text}
          </p>
        </div>

        <div className="body-section-card">
          {children}
          <div
            style={{ display: "flex", width: "100%", justifyContent: "end" }}
          >
            <button
              className="cta-button secondary"
              onClick={onButtonClick}
              style={{ width: "100%" }}
            >
              {button_text}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default StandardTwoSectionCard;
